/*
 * /transcripts/new (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import { Container, Divider, Page, PageHeader } from "@psychology/react-ui"
import { ArrowLeft } from "lucide-react"
import { TranscriptForm } from "../../features/transcript/components/transcript-form"
import { authPageLoader } from "../../utils/auth.utils"

export const Route = createFileRoute("/transcripts/new")({
	component: NewTranscriptPage,
	loader: authPageLoader,
})

function NewTranscriptPage() {
	const { user } = Route.useLoaderData()

	return (
		<Page centerVertical={false}>
			<Container width={"xl"} padding={"lg"} gap={"sm"}>
				<PageHeader
					title={"New Transcript"}
					left={{
						href: "/transcripts",
						label: "Back",
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				<div className={"w-full py-6"}>
					<TranscriptForm user={user} />
				</div>
			</Container>
		</Page>
	)
}
